// extracted by mini-css-extract-plugin
export default {"sectiontitle":"AddHistoryItemModal_sectiontitle__hayic","section":"AddHistoryItemModal_section__E8iNm","label":"AddHistoryItemModal_label__mo5D2"};